import { render, staticRenderFns } from "./BySubject.vue?vue&type=template&id=0cdb710c&"
import script from "./BySubject.vue?vue&type=script&lang=js&"
export * from "./BySubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports